export default {"src":"/_next/static/media/verified-tick.569a3e4f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};